import { PropsWithChildren } from "react"

interface MapPanelTabContentProps {
    panelTabContentHeight?: number,
}

export const MapPanelTabContent = (
    {
        children,
        panelTabContentHeight = 0
    }: PropsWithChildren<MapPanelTabContentProps>) => {
    return (
        <div className="google-map-panel-tab-content"
            style={{ height: panelTabContentHeight } }>
            {children}
        </div>
    )
}
